import { ItemList } from "../orm";

class ProcessGalleryPhotographsProgressList extends ItemList {
  getEntityKey() {
    return "photographer/gallery/process_uploaded_photographs_progress";
  }

  processGalleryPhotographsProgress(galleryId) {
    return async (dispatch, getState) => {
      console.log("processGalleryPhotographsProgress", galleryId);
      await dispatch(this.clearListFilter());
      await dispatch(
        this.updateListFilter({
          gallery_id: galleryId,
        }),
      );
      if (galleryId) {
        return await dispatch(this.fetchListIfNeeded());
      }
      return Promise.resolve({});
    };
  }
}

export const processGalleryPhotographsProgressList =
  new ProcessGalleryPhotographsProgressList(
    "process_gallery_photographs_progress__default",
  );
